import { type CookieSetOptions } from 'universal-cookie/cjs/types';

export type SpeechToTextSource = 'file' | 'youtube';

/**
 * Payload the Speech to Text funnel reads from the
 * `funnel_speech_to_text_from_landing` cookie on its first render.
 * `url` is a YouTube link as typed, or the view URL of an uploaded file.
 */
export const buildSpeechToTextCookie = (
	source: SpeechToTextSource,
	url: string,
): Record<string, string> => ({ source, url });

/** A day is plenty — the funnel never deletes the cookie, it only re-reads it */
export const SPEECH_TO_TEXT_COOKIE_OPTIONS: CookieSetOptions = {
	path: '/',
	maxAge: 60 * 60 * 24,
	sameSite: 'lax',
	secure:
		typeof window !== 'undefined' && window.location.protocol === 'https:',
};
